import React, { useState, useEffect } from "react";
import {Card, Container,Col,Row,Button,Table} from "react-bootstrap";
import { Input } from "reactstrap";
import Loader from "react-loader-spinner";
import {uploadCustomerInfo} from "../services/customerService";
import { set } from "date-fns";


function CustomerInfo() {
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [cinNumber, setCinNumber] = useState(null);
    const [cinFront, setCinFront] = useState(null);
    const [cinBack, setCinBack] = useState(null);
    const [selfie, setSelfie] = useState(null);

    const initData =()=> {
      setPhoneNumber(null)
      setFirstName(null)
      setLastName(null)
      setCinNumber(null)
      setCinFront(null)
      setCinBack(null)
      setSelfie(null)
    }

    const uploadInfo = async () => {
        if(phoneNumber == null || phoneNumber == ''){
        alert('Veuillez vous assurer d\'entrer le numéro de telephone')
        return;
        }
        if(lastName == null || lastName == ''){
            alert('Veuillez vous assurer d\'entrer le nom')
            return;
        }
        if(firstName ==  null || firstName == ''){
          alert('Veuillez vous assurer d\'entrer le prenom')
          return;
      }
        if(cinNumber == null || cinNumber == ''){
            alert('Veuillez vous assurer d\'entrer le cin')
            return;
        }
        if(cinFront == null){
            alert('Veuillez vous assurer selectioné le image de cin recto')
            return;
        }
        if(cinBack == null){
            alert('Veuillez vous assurer selectioné le image de cin verso')
            return;
        }
        if(selfie == null){
            alert('Veuillez vous assurer selectioné le selfie')
            return;
        }

        var data = {
            phoneNumber,
            firstName,
            lastName,
            cinNumber,
            cinFront,
            cinBack,
            selfie
        };
        console.log(data);
        setLoading(true)
        await uploadCustomerInfo(data);
        initData();
        setLoading(false)
    }

  if(loading){ return (
      <div style={{ flex: 1, textAlign: "center" }}>
        <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
      </div>
    );
  }
  else  {
  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card className="card-plain table-plain-bg">
            <Card.Header>
              <Row style={{ alignItems: "flex-end" }}>
               <Col md="4">
                  <label htmlFor="name">numéro de telephone</label>
                  <Input  onChange={(e) => {
                    setPhoneNumber(e.target.value);
                  }}/>
                </Col>

                <Col md="4">
                  <label htmlFor="name">Nom</label>
                  <Input  onChange={(e) => {
                    setLastName(e.target.value);
                  }}/>
                </Col>
                <Col md="4">
                  <label htmlFor="name">prénom</label>
                  <Input  onChange={(e) => {
                    setFirstName(e.target.value)
                  }}/>
                </Col>
                <Col md="4">
                  <label htmlFor="name">Numéro de CIN</label>
                  <Input  onChange={(e) => {
                    setCinNumber(e.target.value)
                  }}/>
                </Col>
              </Row>
              <Row style={{ alignItems: "flex-end" , marginTop:10 }}>
              <Col md="4">
              <label htmlFor="name">Image CIN recto</label>
               <input type="file" accept="image/jpeg,image/png,image/jpg" onChange={(e)=>setCinFront(e.target.files[0])} name="image1"/>
                </Col>
                <Col md="4">
              <label htmlFor="name">Image CIN verso</label>
               <input type="file" accept="image/jpeg,image/png,image/jpg" onChange={(e)=>setCinBack(e.target.files[0])} name="image2" />
                </Col>
                <Col md="4">
              <label htmlFor="name">selfie d'utilisateur</label>
               <input type="file" accept="image/jpeg,image/png,image/jpg" onChange={(e)=>setSelfie(e.target.files[0])} name="selfie"/>
                </Col>
              </Row>
              <Row style={{ alignItems: "flex-end" , marginTop:20}}>
              <Col md="4">
              <Button onClick={() => {
                   uploadInfo();
                  }} variant="success" >sauvegarder</Button>
                </Col>
              </Row>
            </Card.Header>
          </Card>
        </Col>
      </Row>
    </Container>
  );
                }
}

export default CustomerInfo;
